import { useQuery } from 'react-query';

import { getServiceSelection } from 'queries';
import { Toast } from 'helpers';
import { JsonDataItem } from 'types';
import { BookingStore } from 'store';

export const useServiceSelection = (callback: JsonDataItem | null) => {
  const { setServiceList } = BookingStore;

  const {
    isLoading: isServiceListLoading,
    error: serviceListError,
    isSuccess: isServiceListReceived,
    refetch: refetchServiceList,
  } = useQuery(
    ['service-selection', callback ? { product_id: callback.record.product_ID } : null],
    getServiceSelection,
    {
      onSuccess: (data) => setServiceList(data),
      onError: (_: JsonDataItem) => {
        Toast.show({ description: 'Error trying to retrieve device informtion', type: Toast.Type.Error });
      },
    },
  );

  return {
    isServiceListLoading,
    serviceListError,
    isServiceListReceived,
    refetchServiceList,
  };
};
